import React, { useState } from "react"
import Avatar from "../Avatar"

import OutsideClickHandler from "react-outside-click-handler"
import { Button } from "../DesignSystem"

import "./index.scss"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

export function ProfileOptions() {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user } = useSelector((state) => state.app)

  function handleLogout() {
    localStorage.removeItem("user")
    localStorage.removeItem("goto")
    dispatch({ type: "CHANGE_USER", user: null })
    dispatch({ type: "RESET_CHARGE_INFO" })
    dispatch({ type: "RESET_KEYWORD" })
    navigate("/login")
  }

  return (
    <div className="profile-options">
      <div onClick={() => setIsOpen(true)}>
        <Avatar name={user.name} />
        <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
          <div
            className={`profile-options__popper ${
              isOpen ? "profile-options__popper--open" : ""
            }`}
          >
            <Button onClick={handleLogout}>Logout</Button>
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  )
}
